module.exports = __webpack_public_path__ + "img/bobby.222064b.webp";